






import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState(["userAvatar", "userName"])
  }
})
export default class UserAvatar extends Vue {
  @Prop({ default: null }) private avatar?: string;

  // Mapped from vuex
  userAvatar!: string;
  userName!: string;

  // Getters
  get newUserAvatar() {
    if (this.avatar) {
      return this.avatar;
    }

    if (this.userAvatar) {
      return this.userAvatar;
    }

    let name = "somename";

    if (this.userName) {
      name = this.userName.replace(/[^a-z0-9]+/i, "");
    }

    return `https://avatars.dicebear.com/v2/human/${name}.svg?options[mood][]=happy`;
  }
}
